module.exports = __webpack_public_path__ + "static/media/Icon_2.b70c6002.svg";